import styled from 'styled-components'

const Panel = styled.div`
  width: ${props => props.fullWidth ? '100%' : '48%'};
  margin-right: 2%;
  margin-bottom: 2%;
  border-width: 1;
  border-radius: 2px;
  border-color: #aaa;
  box-shadow: 0px 1px 2px 0px rgba(9, 30, 66, 0.25);
  padding: 10px;
  background-color: #fff;
`

export default Panel
